import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { User } from '../models/user';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppPermissionsCheck } from '../interfaces/authentication.typecheck';
import {PermissionsCheck} from '../interfaces/authentication.typecheck';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  APIURL = environment.baseUrl;
  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;
  profile!: any;
  isIframe = false;
  loginDisplay = false;
  accessToken: any;
  userSettings: any;
  modulePermissionCheck: AppPermissionsCheck;
  private readonly _destroying$ = new Subject<void>();
  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    this.userSubject = new BehaviorSubject<User>(this.profile);
    this.user = this.userSubject.asObservable();

    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    this.setLoginDisplay();

    this.modulePermissionCheck = {}; 
    this.getUserAllModuleLevelRoleSettings().subscribe((data) => {
      this.userSettings = data;
    // Loop through the data and populate modulePermissionCheck based on module name
      data.forEach((item) => {
        this.modulePermissionCheck[item.module.toLowerCase()] = item;
      });
    });
  }
  public get userValue(): User {
    return this.userSubject.value;
  }

  getProfile() {
    this.http
      .get('https://graph.microsoft.com/v1.0/me')
      .subscribe((profile: any) => {
       this.userSubject.next(profile);
        localStorage.setItem('user', JSON.stringify(profile));
        this.profile = profile;
      });
  }

  getPhoto() {
    this.http
      .get('https://graph.microsoft.com/v1.0/me/photo/$value', {
        responseType: 'blob',
      })
      .subscribe(async (data) => {
        const pictureBlob = await data;
      });
  }

  getProfilePicture() {
    this.http
      .get('https://graph.microsoft.com/v2.0/me/photo/$value')
      .subscribe((picture) => {
        return picture;
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.msalService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService
        .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
        });
    } else {
      this.msalService
        .loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
        });
    }
  }

  logout(popup?: boolean) {
    localStorage.clear();
    if (popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.msalService.logoutRedirect();
    }
  }

  public GetAccessToken(): any {
    const accessTokenRequest = {
      scopes: ['user.read'],
      account: this.msalService.instance.getAllAccounts()[0],
    };

    this.msalService
      .acquireTokenSilent(accessTokenRequest)
      .subscribe((accessTokenReponse) => {
        if (accessTokenReponse != null) {
          let accessToken = accessTokenReponse.accessToken;
          return accessToken;
        }
      });
  }
  
  getUserModuleViewAccess(): Observable<any> {
    return this.http.get<any>(`${this.APIURL}auth/getModuleViewAccessByUser`);
  }

  getPermissions(): Observable<any> {
    return this.http.get<any>(`${this.APIURL}auth/getUserRoleSettings`);
  }

  getUserPermissionsOnModules(moduleName:string): Observable<any> {
    return this.http.get<any>(`${this.APIURL}auth/getUserModuleLevelRoleSettings?ModuleName=`+moduleName);
  }
  getUserAllModuleLevelRoleSettings(): Observable<any> {
    return this.http.get<any>(`${this.APIURL}auth/getUserAllModuleLevelRoleSettings`);
  }
  
}
